import restApi from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApi.post("/api/customer-locations", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/customer-locations/csv", params);
};

const get = id => {
  return restApi.get(`/api/customer-locations/${id}`);
};

const upsert = data => {
  return restApi.post("/api/customer-locations/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/customer-locations/${ids}`);
};

const customerLocationService = {
  getAll,
  getAllForCSV,
  get,
  upsert,
  remove
};

export default customerLocationService;